export default "__VITE_ASSET__CxX3adoK__"